import { initContract } from '@ts-rest/core';
import { apiAdmin } from './contracts/admin/contract.admin';
import { apiAi } from './contracts/ai/contract.ai';
import { apiAccounts } from './contracts/contract.accounts';
import { apiAccountMembers } from './contracts/contract.accounts.members';
import { apiConnections } from './contracts/contract.connections';
import { apiHealth } from './contracts/contract.health';
import { apiIdentities } from './contracts/contract.identities';
import { apiIntegrations } from './contracts/contract.integrations';
import { apiMemories } from './contracts/contract.memories';
import { apiNotifications } from './contracts/contract.notifications';
import { apiProjectSuggestions } from './contracts/contract.project_suggestions';
import { apiPusher } from './contracts/contract.pusher';
import { apiResources } from './contracts/contract.resources';
import { apiSync } from './contracts/contract.sync';
import { apiTimesheetProposals } from './contracts/contract.timesheet_proposals';
import { apiTools } from './contracts/contract.tools';
import { apiUsers } from './contracts/contract.users';
import { apiTimely } from './contracts/timely/contract.timely';

const c = initContract();
/**
 * API specifications as single source of truth for the API & connected services.
 * @link https://ts-rest.com/docs/core/
 */

type ApiSpec = {
  timely: typeof apiTimely;
  memories: typeof apiMemories;
  ai: typeof apiAi;
  tools: typeof apiTools;
  pusher: typeof apiPusher;
  admin: typeof apiAdmin;
  integrations: typeof apiIntegrations;
  connections: typeof apiConnections;
  sync: typeof apiSync;
  users: typeof apiUsers;
  accounts: typeof apiAccounts;
  members: typeof apiAccountMembers;
  health: typeof apiHealth;
  resources: typeof apiResources;
  identities: typeof apiIdentities;
  notifications: typeof apiNotifications;
  timesheetProposals: typeof apiTimesheetProposals;
  projectSuggestions: typeof apiProjectSuggestions;
};

export const apiSpec: ApiSpec = c.router(
  {
    timely: apiTimely,
    memories: apiMemories,
    ai: apiAi,
    tools: apiTools,
    pusher: apiPusher,
    admin: apiAdmin,
    integrations: apiIntegrations,
    connections: apiConnections,
    sync: apiSync,
    users: apiUsers,
    accounts: apiAccounts,
    members: apiAccountMembers,
    health: apiHealth,
    resources: apiResources,
    identities: apiIdentities,
    notifications: apiNotifications,
    timesheetProposals: apiTimesheetProposals,
    projectSuggestions: apiProjectSuggestions,
  },
  {}
);
